export default __webpack_public_path__ + "static/media/Jio.7da5e792.svg";